import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase/config';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkAdminStatus = async (user) => {
    if (!user) {
      setAdmin(null);
      setLoading(false);
      return;
    }

    try {
      // Get the ID token to access custom claims
      const idTokenResult = await user.getIdTokenResult();
      
      // Check if user has admin role in custom claims
      if (idTokenResult.claims.role === 'admin') {
        setAdmin({
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          role: 'admin',
          permissions: idTokenResult.claims.permissions || []
        });
      } else {
        setAdmin(null);
      }
    } catch (err) {
      console.error('Error checking admin status:', err);
      setError(err.message);
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      checkAdminStatus(user);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    admin,
    loading,
    error,
    isAdmin: !!admin,
    checkAdminStatus
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
}; 